import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleStock } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheStockComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const stockCombo = computed(() => {
    const stocks = store.getters[`${ModuleStock}/items`];
    return stocks.filter(x => !x.inactive && !x.is_parent);
  });

  // config columns combo
  const cacheStockComboConfig = reactive({
    data: stockCombo,
    columns: [
      {
        title: 'Mã kho',
        dataField: 'stock_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên kho',
        dataField: 'stock_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'stock_code',
    valueField: 'stock_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'stock_id',
      titleSearch: 'Tìm nhanh kho',
    },
  });

  return {
    cacheStockComboConfig,
  };
};
